import React, { ReactNode, useRef } from "react";

import {
  BookingEditModeStoreContext,
  BookingEditModeStoreInstance,
  createBookingEditModeStore
} from "../booking_edit_mode_store";

export interface BookingEditModeStoreProviderProps {
  children: ReactNode;
}

export const BookingEditModeStoreProvider: React.FC<BookingEditModeStoreProviderProps> = ({ children }) => {
  const storeRef = useRef<BookingEditModeStoreInstance | undefined>(undefined);

  // eslint-disable-next-line react-hooks/refs
  if (!storeRef.current) {
    storeRef.current = createBookingEditModeStore();
  }

  return (
    // eslint-disable-next-line react-hooks/refs
    <BookingEditModeStoreContext.Provider value={storeRef.current}>
      {children}
    </BookingEditModeStoreContext.Provider>
  );
};
